module.exports = __webpack_public_path__ + "static/img/message_data_none@3x.4aaf040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message_data_none@3x.png
// module id = IWAK
// module chunks = 1